import { css } from '@emotion/react';
import { theme } from 'global';

export const marketingWrapper = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 586px;
`;

export const marketingLogo = css`
  margin-top: 20px;
`;

export const marketingContent = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: break-spaces;
  margin-top: -90px;
`;

export const marketingTitle = css`
  color: ${theme.colors.secondary};
  font-family: ${theme.fonts.title2.family};
  font-weight: 600;
  font-size: ${theme.fontSizes.title2};
  line-height: ${theme.lineHeights.title2};
  margin: 0 0 20px 0;
`;

export const featureList = css`
  display: grid;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;

  li {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 10px;
    align-items: start;
  }
`;

export const featureIcon = css`
  color: ${theme.colors.primary.medium};
  font-size: 16px;
`;

export const featureText = css`
  color: ${theme.colors.neutral[500]};
  font-family: ${theme.fonts.body4.family};
  font-size: ${theme.fontSizes.body4};
  font-weight: ${theme.fontWeights.normal};
  line-height: ${theme.lineHeights.body4};
`;

export const merchantLogos = css`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;

  img {
    width: 80px;
    height: 40px;
    object-fit: contain;
    justify-self: start;
  }
`;
